Greenmile.Task = Greenmile.Task || {};
Greenmile.Task.Comments = {
    comments: [],

    getValue () {
        return this.comments;
    },

    setValue (comments = []) {
        if (comments?.length) {
            const commentsWithTimestamp = this.insertTimestampToComments(comments);
            const commentsSorted = this.sortComments(commentsWithTimestamp);
            this.setComments(commentsSorted);
            this.renderComments();
        }
    },

    add (comment) {
        this.comments.push(comment);
    },

    edit ({ when }, newNote) {
        this.comments.find((comment) => comment.when === when).note = newNote;
    },

    delete (indexToRemove, target) {
        const singleCommentElement = target.parentNode.parentNode;
        const commentContainer = document.querySelector('#Task .taskCommentContainer .taskComment__content');
        commentContainer.removeChild(singleCommentElement);
        
        const commentToRemove = this.comments[indexToRemove];
        this.comments.splice(indexToRemove, 1);

        if (commentToRemove.id) {
            const request = new Monet.Ajax();
            request.url = 'TaskComment/' + commentToRemove.id;
            request.method = 'delete';
            request.send();
        }
    },

    rootEl: {
        className: ''
    },

    validate: () => [],

    render: function () {
        const taskForm = document.querySelector('#Task .MonetUIForm');
        const commentContainer = this.buildSection();
        const commentContent = document.createElement('div');
        const resetCommentsData = () => this.setComments([]);
        const setToFieldsToValuesBeRenderByMonet = () => {
            App.Forms.Task.form.fields.comments = this;
        };

        commentContent.className = 'taskComment__content';
        commentContainer.appendChild(commentContent);

        if (taskForm) {
            const buttonsDownSection = document.querySelector(
                "#Task .MonetUIFormSectionButton.buttonsDown"
            )?.parentElement;

            taskForm.insertBefore(commentContainer, buttonsDownSection);
        }

        this.renderAddButton();
        resetCommentsData();
        setToFieldsToValuesBeRenderByMonet();
    },

    renderAddButton: function () {
        var taskForm         = document.querySelector('#Task .MonetUIForm'),
            divContainer     = document.createElement('div'),
            addCommentButton = document.createElement('input'),
            buttonContainer  = document.createElement('div');

        addCommentButton.type = 'button';
        addCommentButton.name = 'add_comment';
        addCommentButton.value = Monet.I18n.getResourcesByKey('Task.addComment');
        addCommentButton.className = 'btn i18nResource';

        addCommentButton.addEventListener('click', () => this.addCommentContainer());

        buttonContainer.id = 'TaskAddCommentContainer';
        buttonContainer.appendChild(addCommentButton);

        divContainer.id = 'taskCommentEditor';
        divContainer.appendChild(buttonContainer);

        if (taskForm) {
            var buttonsDownSection = document.querySelector('#Task .MonetUIFormSectionButton.buttonsDown').parentElement;
            taskForm.insertBefore(divContainer, buttonsDownSection);
        }
    },

    renderEditor: function (textArea, saveButton, cancelButton) {
        const commentContainer = document.createElement('div');
        const taskCommentEditor = document.querySelector('#taskCommentEditor');
        const taskCommentButtonContainer = document.createElement('div');

        while (taskCommentEditor.firstChild) {
            taskCommentEditor.removeChild(taskCommentEditor.firstChild);
        }

        taskCommentButtonContainer.id = 'taskCommentButtonContainer';
        taskCommentButtonContainer.appendChild(cancelButton);
        taskCommentButtonContainer.appendChild(saveButton);

        commentContainer.id = 'CommentTextAreaContainer';
        commentContainer.appendChild(textArea);

        taskCommentEditor.appendChild(commentContainer);
        taskCommentEditor.appendChild(taskCommentButtonContainer);
    },

    removeEditor: function () {
        const commentContainer = document.querySelector('#taskCommentEditor');
        const containerParent  = commentContainer.parentNode;
        containerParent.removeChild(commentContainer);
        this.renderAddButton();
    },

    renderComment: function (comment) {

        var commentContainer = document.querySelector('#Task .taskCommentContainer .taskComment__content'),
            singleComment    = document.createElement('div'),
            commentOwner     = document.createElement('div'),
            commentText      = document.createElement('div'),
            bold             = document.createElement('b'),
            divDestroy       = document.createElement('div'),
            divEdit          = document.createElement('div'),
            loggedUser       = Monet.Session.User,
            timestamp        = new Date(comment.when),
            timestampString  = timestamp.getTime().toString();
        const commentHeader = document.createElement('div');

        const formattedDate = Monet.Format.DateTime.formatToLocale(comment.when);

        commentHeader.className = 'singleComment__header';
        divDestroy.className = "table-action-destroylink";
        divDestroy.innerHTML = "&nbsp;";
        divDestroy.addEventListener('click', (event) => {
            const confirmDelete = () => {
                this.removeComment(event.target, timestampString);
            };

            new Greenmile.Components.AlertModal('lookuplist.message.alertExclude',
                null,
                confirmDelete)
            .show();
        });

        divEdit.className = "table-action-editlink";
        divEdit.innerHTML = "&nbsp;";
        divEdit.addEventListener('click', () => this.editCommentContainer(comment, timestampString));

        bold.innerHTML = comment.userCreated.name;
        commentOwner.innerHTML = bold.outerHTML + ' ' + Monet.I18n.getResourcesByKey('task.comment.added') + ' - ' + formattedDate;
        commentOwner.className = 'commentOwner';

        commentText.innerHTML = comment.note;
        commentText.className = 'commentText';
        commentText.id = 'commentText_' + timestampString;

        singleComment.className = 'singleComment';

        commentHeader.appendChild(commentOwner);

        if (comment.userCreated.id === loggedUser.id) {
            commentHeader.appendChild(divEdit);
            commentHeader.appendChild(divDestroy);
        }

        singleComment.appendChild(commentHeader);
        singleComment.appendChild(commentText);

        commentContainer.appendChild(singleComment);
    },

    addCommentContainer: function () {
        var textArea     = document.createElement('textarea'),
            saveButton   = document.createElement('input'),
            cancelButton = document.createElement('input'),
            cancelAction,
            saveAction;

        saveButton.type = 'button';
        saveButton.className = 'btn i18nResource';
        saveButton.value = Monet.I18n.getResourcesByKey('task.comment.save');

        cancelButton.type = 'button';
        cancelButton.className = 'btn i18nResource';
        cancelButton.value = Monet.I18n.getResourcesByKey('task.comment.cancel');

        cancelAction = () => { this.removeEditor() };

        saveAction = () => {
            const comment = {
                note: textArea.value,
                when: Monet.Format.DateTime.getTodayISOString(),
                userCreated: Monet.Session.User
            };

            this.add(comment);
            this.renderComment(comment);
            this.removeEditor();
        };

        saveButton.removeEventListener('click', saveAction);
        saveButton.addEventListener('click', saveAction);

        cancelButton.removeEventListener('click', cancelAction);
        cancelButton.addEventListener('click', cancelAction);

        this.renderEditor(textArea, saveButton, cancelButton);
    },

    editCommentContainer: function (comment, elementTimestamp) {
        var commentText = document.getElementById('commentText_' + elementTimestamp),
            textArea    = document.createElement('textarea'),
            saveButton  = document.createElement('input'),
            saveAction;

        textArea.value = commentText.innerHTML;
        textArea.className = 'editCommentArea';

        saveButton.type = 'button';
        saveButton.className = 'editCommentButton';
        saveButton.value = Monet.I18n.getResourcesByKey('task.comment.save');

        commentText.innerHTML = '';
        commentText.appendChild(textArea);
        commentText.appendChild(saveButton);

        saveAction = () => {
            this.edit(comment, textArea.value);
            const commentText = document.getElementById('commentText_' + elementTimestamp);
            commentText.innerHTML = textArea.value;
        };

        saveButton.removeEventListener('click', saveAction);
        saveButton.addEventListener('click', saveAction);
    },

    removeComment: function (target, elementTimestamp) {
        const indexToRemove = this.comments.findIndex((comment => 
            Monet.Format.DateTime.parse(comment.when).getTime() == elementTimestamp)
        );

        if(indexToRemove >= 0) {
            this.delete(indexToRemove, target);
        } else { 
            new Monet.Exception.ReturnError(this, "No comment found to be removed.")
                .console();
        }
    },

    buildSection: () => {
        const sectionBuilder = new Monet.Builder.Form.Horizontal();
        const sectionContainer = sectionBuilder.createContainer(
            `MonetUIFormSection taskCommentContainer`
        );
        const sectionToRender = sectionBuilder.renderAndAppendTitle(
            sectionContainer,
            { description: Monet.I18n.getResourcesByKey("Task.header.comments") }
        );

        return sectionToRender;
    },

    insertTimestampToComments: (comments) =>
        comments.map(comment => {
            const commentWithTimestamp = comment;
            const date = new Date(comment.when);
            const timestamp = date.getTime();

            commentWithTimestamp.timestamp = timestamp;
            return commentWithTimestamp;
        }),
    
    sortComments: (commentsWithTimestamp) =>
        commentsWithTimestamp.sort((a, b) => a.timestamp - b.timestamp),

    renderComments () {
        this.comments.forEach((comment) => this.renderComment(comment));
    },

    setComments (comments) {
        this.comments = comments;
    }
};
